(function(Drupal, $, once) {
  Drupal.behaviors.mega_menu = {
    attach: function (context, settings) {

      once(
        'dropdown-menu',
        '#block-wcpfc-public-cms-theme-mega-menu-headings', context
      ).forEach((menu, index) => {

        let $menuItems = $(menu).find('ul.main-menu > li.menuparent');

        $menuItems.each(function() {
          let $parentLi = $(this);
          // Target the text span (.nolink) or the anchor tag (.link) inside the li
          let $heading = $parentLi.children('.nolink, a.link');

          $heading.on('click', function(e) {
            // If the heading is just text (no-link) or a # link, prevent it from jumping to top of page
            if ($(this).hasClass('nolink') || $(this).attr('href') === '#') {
              e.preventDefault();
            }

            // Toggle the 'open' class on the clicked menu item
            $parentLi.toggleClass('open');

            // Close any other open dropdowns so only one is open at a time
            $parentLi.siblings('li.menuparent').removeClass('open');
          });
        });

        // Close the dropdown if the user clicks anywhere else on the screen
        $(document).on('click', function(e) {
          if (!$(e.target).closest('#block-wcpfc-public-cms-theme-mega-menu-headings').length) {
            $menuItems.removeClass('open');
          }
        });

      });

    }
  };
})(Drupal, jQuery, once);
